<template>
    <div>
        <!-- Modal -->
        <div class="modal fade" id="incluirOrcamentoProcedimentosModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
                <div class="modal-content" v-if="id_orcamento">
                    <div class="modal-header">
                        <h5 class="modal-title">Orçamento
                            <span class="badge badge-secondary ml-2">#{{ id_orcamento }}</span>
                        </h5>
                        <button type="button" class="close" @click="fechar_modal()" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <az-loading v-if="$store.state.loading" />

                        <table class="table table-sm small" v-else>
                            <thead>
                                <tr>
                                    <th></th>
                                    <th>No.</th>
                                    <th>Procedimento</th>
                                    <th>Sigla</th>
                                    <th class="text-right">Qtd</th>
                                    <th class="text-right">Valor</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(proced, ipx) in lista_procedimentos" :key="ipx">
                                    <td>
                                        <input type="checkbox" v-model="proced.selected" :disabled="!proced.pode_selecionar"/>
                                    </td>
                                    <td>{{ ipx + 1 }}</td>
                                    <td>{{ proced.procedimento ? proced.procedimento.st_procedimento : '' }}</td>
                                    <td>{{ proced.procedimento ? proced.procedimento.st_sigla : '' }}</td>
                                    <td class="text-right">{{ proced.in_quantidade }}</td>
                                    <td class="text-right">{{ $util.formatMoeda(proced.dc_valor_procedimento * proced.in_quantidade) }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" @click="fechar_modal()">Cancelar</button>
                        <button type="button" class="btn btn-success" @click="incluir()">Incluir</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery';
import AzLoading from '../../util/AzLoading.vue';

export default {
    data() {
        return {
            id_orcamento: null,
            orcamento: null, 
        }
    },

    components: { 
        AzLoading, 
    },

    computed: { 
        lista_procedimentos: function () { 
            if ( this.orcamento && this.orcamento.js_procedimentos ) { 
                return this.orcamento.js_procedimentos;
            }

            return null; 
        }
    },

    methods: { 
        incluir () { 
            let codigos = this.lista_procedimentos.filter(p => p.selected && p.procedimento && p.procedimento.st_sigla)
                .map(p => p.procedimento.st_sigla)
                .join(',');

            if ( codigos ) { 
                this.$parent.incluir_codigos(codigos + ',');
                this.fechar_modal ();

                this.$nextTick(() => { 
                    if ( this.$parent.$refs.info_procedimento && this.$parent.$refs.info_procedimento.$refs.input ) { 
                        this.$parent.$refs.info_procedimento.$refs.input.focus();
                    }
                });
            } else { 
                this.$toast.add({ 
                    severity: 'warn', 
                    summary: 'Nenhum procedimento selecionado', 
                    detail: 'Selecione os procedimentos que deseja incluir.',
                    life: 3000 
                });
            }
        },

        condicao (proced) { 
            console.log('proced', proced);
            return '?'; 
        },

        fechar_modal () { 
            $('#incluirOrcamentoProcedimentosModal').modal('hide');
        },

        tem_marcacao (orcamento, id_procedimento) { 
            if ( !orcamento || !orcamento.marcacoes ) { 
                return false;
            }

            return orcamento.marcacoes.find(p => p.id_procedimento == id_procedimento || (p.js_outros_procedimentos && p.js_outros_procedimentos.find(op => op.id_procedimento == id_procedimento)));
        },

        abrir (id_orcamento) { 
            this.orcamento = null; 
            this.id_orcamento = id_orcamento; 
            $('#incluirOrcamentoProcedimentosModal').modal('show');

            this.$util.load(this, { 
                service: 'orcamentos',
                func: 'show', 
                parms: {  
                    id: id_orcamento, 
                    sel_orcamento: true, 
                    recepcao: true, 
                },
                loadTo: res => { 
                    res.js_procedimentos = res.js_procedimentos.map(p => { 
                        p.selected = false;
                        p.pode_selecionar = false; 

                        if ( p.procedimento ) { 
                            if ( !this.tem_marcacao(res, p.procedimento.id_procedimento)) { 
                                p.selected = true;
                                p.pode_selecionar = true; 
                            }
                        }

                        return p;
                    });

                    this.orcamento = res;
                }
            });
        }
    }
}
</script>
